import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { DrawerContainer } from '../DrawerContainer/DrawerContainer';

@Component
export class OptionInfo extends ThemeComponent {
    @Ref({ required: true }) button!: HTMLButtonElement;

    @Prop identifier!: string;

    private drawerContainer: DrawerContainer|null = null;
    private optionInfo: DrawerContainer|null = document.querySelector('.js-option-info');

    init() {
        this.drawerContainer = document.querySelector(`drawer-container[data-identifier='${this.identifier}']`);

        if (this.drawerContainer == null) {return;}

        this.$listen(this.button, 'click', () => {
            if (this.optionInfo) {
                this.optionInfo.dataset.identifier = `${this.getAttribute('identifier')}`;

                if (this.drawerContainer) {
                    this.optionInfo.innerHTML = this.drawerContainer?.innerHTML;
                    this.optionInfo.open();

                    const closeButton = this.optionInfo.querySelector('.js-close-button') as HTMLButtonElement;
                    if (closeButton) {
                        closeButton.addEventListener('click', () => {
                            this.drawerContainer?.close();
                            this.optionInfo?.close();
                        });
                    }
                }
            }

            // Show sidedrawer
            this.drawerContainer?.open();
        });
    }
}
